<template>
  <el-scrollbar class='sidebar'>
    <el-menu class="sidebar-el-menu" :default-active="onRoutes" :collapse="collapse"
      unique-opened router>
      <template v-for="item in items">
        <template v-if="item.subs">
          <el-submenu :index="item.title" :key="item.id">
            <template slot="title">
              <i :class="item.icon"></i><span slot="title">{{ item.title }}</span>
            </template>
            <template v-for="subItem in item.subs">
              <template v-if="subItem.subs">
                <el-submenu :index="subItem.title" :key="subItem.id">
                  <template slot="title">{{ subItem.title }}</template>
                  <el-menu-item v-for="(threeItem, i) in subItem.subs" :key="i" :index="threeItem.index">
                    {{ threeItem.title }}
                  </el-menu-item>
                </el-submenu>
              </template>
              <template v-else>
                <el-menu-item :index="subItem.index" :key="subItem.id">
                  {{ subItem.title }}
                </el-menu-item>
              </template>
            </template>
          </el-submenu>
        </template>
        <template v-else>
          <el-menu-item :index="item.index" :key="item.id">
            <i :class="item.icon"></i><span slot="title">{{ item.title }}</span>
          </el-menu-item>
        </template>
      </template>
    </el-menu>
  </el-scrollbar>
</template>

<script>
import transmit from './../common/transmit'

export default {
  name: 'sidebar',
  props: {
    message: Boolean
  },

  data () {
    return {
      collapse: false,
      items: [{
        id: '1',
        icon: 'Admin Admin-tubiao',
        title: '数据统计',
        subs: [{
          id: '1-1',
          icon: 'Admin Admin-tubiao',
          index: '/index/chartStatistics',
          title: '图表统计'
        },
        {
          id: '1-2',
          // icon: 'Admin Admin-liebiao',
          index: '/index/userStatistics',
          title: '用户信息'
        }]
      },
      {
        id: '2',
        icon: 'Admin Admin-houtailunbo',
        title: '轮播图',
        subs: [{
          id: '2-1',
          // icon: 'Admin Admin-liebiao',
          index: '/index/carousel',
          title: '轮播图管理列表'
        }]
      },
      {
        id: '3',
        icon: 'Admin Admin-meiriyidu',
        title: '每日阅读',
        subs: [{
          id: '3-1',
          // icon: 'Admin Admin-liebiao',
          index: '/index/drafts',
          title: '草稿箱'
        },
        {
          id: '3-2',
          // icon: 'Admin Admin-liebiao',
          index: '/index/releasing',
          title: '发布中'
        },
        {
          id: '3-3',
          // icon: 'Admin Admin-liebiao',
          index: '/index/revoked',
          title: '已下架'
        },
        {
          id: '3-4',
          // icon: 'Admin Admin-liebiao',
          index: '/index/comments',
          title: '评论管理'
        }]
      },
      {
        id: '10',
        icon: 'Admin Admin-biaoge',
        title: '课程管理',
        subs: [{
          id: '10-1',
          // icon: 'Admin Admin-liebiao',
          index: '/index/trainingCamp',
          title: '训练营管理'
        }, {
          id: '10-12',
          // icon: 'Admin Admin-liebiao',
          index: '/index/catalog',
          title: '目录管理'
        }, {
          id: '10-13',
          // icon: 'Admin Admin-liebiao',
          index: '/index/homework',
          title: '作业管理'
        }, {
          id: '10-2',
          // icon: 'Admin Admin-liebiao',
          index: '/index/imageAndText',
          title: '图文管理'
        }, {
          id: '10-4',
          // icon: 'Admin Admin-liebiao',
          index: '/index/audio',
          title: '音频管理'
        }, {
          id: '10-3',
          // icon: 'Admin Admin-liebiao',
          index: '/index/video',
          title: '视频管理'
        }, {
          id: '10-11',
          // icon: 'Admin Admin-liebiao',
          index: '/index/examination',
          title: '考试管理'
        }, {
          id: '10-6',
          // icon: 'Admin Admin-liebiao',
          index: '/index/material',
          title: '素材管理'
        }, {
          id: '10-7',
          // icon: 'Admin Admin-liebiao',
          index: '/index/gift',
          title: '教具礼品管理'
        }, {
          id: '10-8',
          // icon: 'Admin Admin-liebiao',
          index: '/index/order',
          title: '订单管理'
        }, {
          id: '10-9',
          // icon: 'Admin Admin-liebiao',
          index: '/index/certificate',
          title: '证书管理'
        }, {
          id: '10-10',
          // icon: 'Admin Admin-liebiao',
          index: '/index/appointment',
          title: '预约管理'
        }, {
          id: '10-14',
          // icon: 'Admin Admin-liebiao',
          index: '/index/ticket',
          title: '优惠券管理'
        }]
      },
      {
        id: '4',
        icon: 'Admin Admin-kalendar',
        title: '黄历',
        subs: [{
          id: '4-1',
          // icon: 'Admin Admin-liebiao',
          index: '/index/calendar',
          title: '黄历管理'
        }]
      },
      {
        id: '5',
        icon: 'Admin Admin-guanli',
        title: '占卜',
        subs: [{
          id: '5-1',
          // icon: 'Admin Admin-liebiao',
          index: '/index/divination',
          title: '卦象管理'
        },
        {
          id: '5-2',
          // icon: 'Admin Admin-liebiao',
          index: '/index/article',
          title: '相关文章'
        },
        {
          id: '6',
          // icon: 'Admin Admin-zhiwenjiesuo',
          title: '卦象解锁管理',
          subs: [{
            id: '6-1',
            // icon: 'Admin Admin-liebiao',
            index: '/index/share',
            title: '分享解锁'
          },
          {
            id: '6-2',
            // icon: 'Admin Admin-liebiao',
            index: '/index/payment',
            title: '支付订单'
          }]
        }]
      },
      {
        id: '7',
        icon: 'Admin Admin-tongzhi',
        title: '通知管理',
        subs: [{
          id: '7-1',
          // icon: 'Admin Admin-liebiao',
          index: '/index/notice',
          title: '通知管理'
        }]
      },
      {
        id: '8',
        icon: 'Admin Admin-tubiaolunkuo-',
        title: '用户反馈管理',
        subs: [{
          id: '8-1',
          // icon: 'Admin Admin-liebiao',
          index: '/index/feedback',
          title: '用户反馈'
        }]
      },
      {
        id: '9',
        icon: 'Admin Admin-quanxianshezhi',
        title: '系统管理',
        subs: [{
          id: '9-1',
          index: '/index/edition',
          title: '版本管理'
        }, {
          id: '9-2',
          index: '/index/protocolYs',
          title: '隐私协议'
        }, {
          id: '9-3',
          index: '/index/protocolFw',
          title: '服务协议'
        }, {
          id: '9-4',
          index: '/index/h5JumpUrl',
          title: '小鹅通报名链接'
        }, {
          id: '9-5',
          index: '/index/book',
          title: '图书管理'
        }, {
          id: '9-6',
          // icon: 'Admin Admin-liebiao',
          index: '/index/member',
          title: '开通有赞会员'
        }, {
          id: '9-7',
          // icon: 'Admin Admin-liebiao',
          index: '/index/applePay',
          title: '支付设置'
        }]
      }]
      // 新增id从11 ，10在上面
    }
  },

  computed: {
    onRoutes () {
      return this.$route.path
    }
  },

  created () {
    transmit.$on('collapse', msg => {
      this.collapse = msg
    })
  }
}
</script>

<style scoped lang="scss">
  .sidebar {
    display: block;
    position: absolute;
    left: 0;
    top: 60px;
    bottom:0;
    overflow-y: hidden;
    z-index: 999;
    text-align: left;

    ul {
      height:100%;
    }

    .Admin {
      font-size: 22px;
      margin-right: 10px;
    }
  }

  .el-scrollbar {
    height: calc(100% - 43px);
  }

  .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  .sidebar::-webkit-scrollbar {
    width: 0;
  }

  .sidebar-el-menu:not(.el-menu--collapse) {
    width: 230px;
  }
</style>



// WEBPACK FOOTER //
// src/components/template/navMenu.vue